import React, { useEffect } from "react";
import * as d3 from "d3";

function PieChart(props) {
  var { data, outerRadius, innerRadius } = props;

  const width = 2 * outerRadius;
  const height = 2 * outerRadius;

  const colorScale = d3
    .scaleLinear()
    .domain([0, data?.length - 1])
    .range(["#00a79e", "#8dc63f"]);

  useEffect(() => {
    drawChart();
  }, [data]);

  function drawChart() {
    // Remove the old svg
    d3.select("#pie-container").select("svg").remove();

    // Create new svg
    const svg = d3
      .select("#pie-container")
      .append("svg")
      .attr("width", width)
      .attr("height", height)
      .append("g")
      .attr("transform", `translate(${width / 2}, ${height / 2})`);

    const arcGenerator = d3
      .arc()
      .innerRadius(innerRadius)
      .outerRadius(outerRadius);

    const pieGenerator = d3
      .pie()
      .padAngle(0)
      .value((d) => d);

    const arc = svg.selectAll().data(pieGenerator(data)).enter();

    // Append arcs
    arc
      .append("path")
      .attr("d", arcGenerator)
      .style("fill", (_, i) => colorScale(i))
      .style("stroke", "#ffffff")
      .style("stroke-width", 0);

    // Append text labels
    arc
      .append("text")
      .attr("text-anchor", "middle")
      .attr("alignment-baseline", "middle")
      .text((d) => d.data?.label)
      .style("fill", (_, i) => colorScale(data?.length - i))
      .attr("transform", (d) => {
        const [x, y] = arcGenerator.centroid(d);
        return `translate(${x}, ${y})`;
      });
    svg
      .append("text")
      .attr("text-anchor", "middle")
      .attr("alignment-baseline", "middle")
      .attr("font-size", "21px")
      .attr("y", "-15")
      .text("Total");
    svg
      .append("text")
      .attr("text-anchor", "middle")
      .attr("alignment-baseline", "middle")
      .attr("font-size", "32px")
      .attr("y", "15")
      .text(() => {
        var total = 0;
        data.map((item) => (total += item));
        return total;
      });
  }

  return <div id="pie-container" />;
}

export default PieChart;
